// extracted by mini-css-extract-plugin
module.exports = {"root":"GiftCard_root__XcD7o","buyContainer":"GiftCard_buyContainer__wKyEY","cta":"GiftCard_cta__N0n6l"};